import type { Control } from 'react-hook-form';
import type { z } from 'zod';

import type { IdUserDto } from '@/services/ws-permissions/src/main/resources/rest-api';

import type { createSchema } from './schema';

export type FormValues = z.infer<ReturnType<typeof createSchema>>;

export interface UserFormRouteParams {
  userId?: IdUserDto;
}

export interface FieldProps {
  isSubmitting: boolean;
  control: Control<FormValues>;
}

export enum UserFormSearchKey {
  USER_DETAILS_TAB = 'userDetailsTab',
}
